import { prop, mergeRight } from 'ramda';
import { loadTexts } from '@twnel/web-components';

export default function fetchTexts() {
  return loadTexts(async (locale) => {
    let loaders;
    switch (locale) {
      case 'es':
        loaders = [
          import('@twnel/web-components/lib/es.json'),
          import('resources/localization/es.json'),
        ];
        break;
      case 'pt':
        loaders = [
          import('@twnel/web-components/lib/pt.json'),
          import('resources/localization/pt.json'),
        ];
        break;
      default:
        return {};
    }
    const result = await Promise.all(loaders);
    return result.map(prop('default')).reduce(mergeRight);
  });
}
